import styled from 'styled-components';

import { spacing } from '../../../../styles/theme';

import BaseLogo from '../../Logo';

export const Container = styled.div`
  width: 70%;
  margin: auto;
`;

export const Logo = styled(BaseLogo)`
  margin: 0 auto ${spacing('3')} auto;
`;

export const Highlight = styled.strong`
  font-weight: 700;
`;

export const TitleContainer = styled.div`
  margin-bottom: ${spacing('6')};
`;
